import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
function Industrial() {
    //  const [active, setActive] = useState("Safe Area");
    //     const navigate = useNavigate();
    const clients = [
        {
            img: "/assets/services/lv-instrumentation-cable.svg",
            title: "Customized Enclosure Solutions",
            text: "IEC, BS and other international standard cables are available as per the site MOQ with the option of cable cutting & pre-terminated cables.",
            link: "/services/lv-instrumentation-cable"
        },
        {
            img: "/assets/services/cable-glands-lugs-terminals.svg",
            title: "Power, Instrumentation &amp; Control cables",
            text: "Certified cable glands and lugs are available to suit the various cable constructions and hazardous area ratings.",
            link: "/services/cable-glands-lugs-terminals"
        },
        {
            img: "/assets/services/enclosing-solutions-polycarbonates.svg",
            title: "Cable Glands – Safe &amp; Hazardous Area",
            text: "Customised solution is a must and unique to any industrial projects. We understand & build considering local climatic conditions.",
            link: "/services/enclosing-solutions-polycarbonates"
        },
        {
            img: "/assets/services/identification-labelling-systems.svg",
            title: "Cable Cleat, Lugs &amp; Terminals",
            text: "Industrial complexes require networks of cables with sophisticated control equipment. We provide identification solutions to increase safety and clarity.",
            link: "/services/identification-labelling-systems"
        },
        {
            img: "/assets/services/cable-management-solutions.svg",
            title: "Identification &amp; Labelling Systems",
            text: "Premium quality cable management products like cable ladders & trays, conduits, ducts, and trunking are available in HDG, Stainless-steel, etc.",
            link: "/services/cable-management-solutions"
        },
        {
            img: "/assets/services/multi-cable-transit-system.svg",
            title: "Electrical Cable Accessories",
            text: "Available in various forms to allow a bunch of cables to pass securely and safely between floor levels and walls, meeting fire, sound-proof, and other statutory requirements.",
            link: "/services/multi-cable-transit-system"
        }
        ,
        {
            img: "/assets/services/cable-management-solutions.svg",
            title: "Rigid &amp; Flexible Conduit",
            text: "Premium quality cable management products like cable ladders & trays, conduits, ducts, and trunking are available in HDG, Stainless-steel, etc.",
            link: "/services/cable-management-solutions"
        },
        {
            img: "/assets/services/cable-management-solutions.svg",
            title: "Metal Products – Plugs, Sockets &amp; Switches",
            text: "Premium quality cable management products like cable ladders & trays, conduits, ducts, and trunking are available in HDG, Stainless-steel, etc.",
            link: "/services/cable-management-solutions"
        },
    ];

    return (
        <>
        <Helmet>
    <title>
        Industrial Electrical & Cable Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides industrial electrical and cable management solutions in the UAE, including customized enclosures, power and instrumentation cables, cable glands, cleats, lugs, conduits, accessories and hazardous area products."
    />

    <meta
        name="keywords"
        content="industrial electrical solutions UAE, industrial cable management UAE, industrial enclosures UAE, power instrumentation cables UAE, hazardous area products UAE, cable glands UAE, cable cleats UAE, cable lugs UAE, industrial conduits UAE, electrical cable accessories UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/industrial"
    />

    <meta
        property="og:title"
        content="Industrial Electrical & Cable Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Industrial electrical, cable management, enclosure and hazardous area solutions for industrial applications across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/industrial"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Industrial</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Enhancing productivity with cutting-edge industrial solutions.
                    </p>
                </div>
            </div>
  <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Industrial</h2>
  <div className='line'></div>
                         <h3 className='text-left'>

                            The need to self-dependency and abundance of oil & gas energy has led to the rapid industrialization in the region. The success story of oil & gas, aluminium, power, cement, fabrication, defence, ship building industry has paved the path for numerous supportive and ancillary units like pharmaceuticals, water, food processing, building materials, electricals, HVAC etc.
We are proud to support the industry with both industrial (safe & hazardous area) and hygienic range of products.
                         </h3>

               </div>
               </div>
            <section className='lg:pt-[10px] pt-[10px] lg:pb-[10px] pb-[60px]'>

              <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[36px]">
  
<div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[90px] gap-[30px]">

  {/* LEFT – Sticky Image */}
  <div className="lg:sticky lg:top-[120px] self-start">
    <div className="mb-[15px] w-full flex justify-center items-center rounded-[12px] p-[22px]">
      <img
        src="/assets/in4.png"
        className="h-[439px] w-full object-cover rounded-[12px]"
        alt="Trusted cable management and termination solutions provider in the UAE"
      />
    </div>
  </div>

  {/* RIGHT – Vertically Centered Content */}
  <div className="pt-[11px] flex flex-col justify-center">
    <ul className="mt-4 grid grid-cols-1">
      {[
        "Customized Enclosure Solutions",
        "Power, Instrumentation & Control cables",
        "Cable Glands – Safe & Hazardous Area",
        "Cable Cleat, Lugs & Terminals",
        "Identification & Labelling Systems",
        "Electrical Cable Accessories",
        "Rigid & Flexible Conduit",
        "Metal Products – Plugs, Sockets & Switches",
      ].map((item, i) => (
        <li
          key={i}
          className="flex items-start gap-3 rounded-lg bg-white px-4 py-1 transition"
        >
          <span className="mt-2 h-2 w-2 rounded-full bg-[#e09e0f]" />
          <span className="text-gray-700 text-[18px] leading-relaxed aplus">
            {item}
          </span>
        </li>
      ))}
    </ul>

    <Link to="/industries">
      <button className="backbtn mt-6">
        Back To Industries
      </button>
    </Link>
  </div>

</div>

</div>


            </section>
            {/* <section className="bg-[#fff] dark:bg-[#FBB210] py-[60px] md:py-[50px]">
                <div className="max-w-[1440px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[50px] px-[20px]">
                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000] dark:text-[#000000] lg:sticky lg:top-[150px] self-start">
                        <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                          We are proud to support the industry with both industrial (safe &amp; hazardous area) and hygienic
range of products.
                        </h6>

                        <div className="group inline-flex items-center cursor-pointer">
                            <i className="bi bi-arrow-right text-[#fff] text-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                        </div>

                    </div>
                    <div className="lg:max-w-[600px] max-w-[100%] w-full">
                        <div className="grid gap-[20px]">
                            {clients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="nsr border group relative rounded-[8px]  backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-transform duration-300 transform hover:scale-[1.03] hover:shadow-lg"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >
                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">

                                            <div className='text-[#000] dark:text-[#000000]'>
                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500]  dark:text-[#000] dark:group-hover:text-white">                                                    {item.title}
                                                </h6>
                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    )
}

export default Industrial